<div class="community mb-3">
  <div class="d-flex w-100 align-items-center">
    <p class="title-3d mb-1 cursor-pointer">
      <span data-text="Trending">Trending</span>
    </p>
    <p class="mb-1 disabled popular-region pt-3" *ngIf="region?.id">
      <span data-text="Region" class="d-none d-md-block text-left">
        in {{ region.name }}
      </span>
      <span data-text="Region" class="d-block d-md-none text-left">
        in {{ region.name.split(',')[0] }}
      </span>
    </p>
  </div>

  <div class="tabs mt-3 no-below smooth-scroll">
    <app-my-carousel-swiper [navigation]="false" class="my-carousel-width-auto" [config]="carouselOptions"
      style="margin-bottom: 0;">
      <div *ngFor="let i of bottomCategories" class="card-sub-cate-full-width swiper-slide" (click)="loadProducts(i)"
        [for]="i?.region" [class.active]="bottomProductsSubCategory == i.name">
        <div class="card-sub-cate-full-width__title cat">
          {{ i.name | titlecase }}
        </div>
      </div>
    </app-my-carousel-swiper>
  </div>

  <div class="tabs mt-1" style="position: relative;">
    <ng-container *ngIf="areThereMore as more">
      <div *ngIf="more"
        style="color: var(--secondary); position: absolute; right: 3%; bottom: 50%; z-index: 1000; font-weight: bold; font-size: 1.6rem">
        <svg width="24" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5l7 7-7 7" stroke="#b32596" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </ng-container>

    <ng-container *ngIf="showtCarousel as showCarousel">
      <app-my-carousel-swiper *ngIf="showCarousel" [navigation]="false" (onSwiper)="onProductsSwiper($event)"
        (onSlideChange)="onProductSlideChange($event)" class="my-carousel-width-auto" [config]="carouselOptions">
        <ng-container *ngFor="let list of allBottomProducts.data; let i = index">
          <common-product-card-view [list]="list" *ngIf="list.outOfStockAll != 1" (view)="viewProductDetails($event)"
            [isCommunityProduct]="true" class="swiper-slide"></common-product-card-view>
        </ng-container>
      </app-my-carousel-swiper>
    </ng-container>
  </div>

  <ng-container *ngIf="isLoading">
    <common-product-card-view-loader [total]="2"></common-product-card-view-loader>
  </ng-container>

  <div class="text-center border-0 p-4" *ngIf="allBottomProducts?.totalCount < 1 && !isLoading">
    <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
    <h2 class="card-title fw-bold text-secondary">No Products Found</h2>
    <p class="card-text text-muted">It seems we couldn’t find any products matching your search. Please try adjusting
      your filters or browse our categories.</p>
  </div>
</div>